<div class="loading-error">
  <app-icon title="Loading error" [size]="IconSize.MEDIUM">warning</app-icon>
  <p><ng-content></ng-content></p>
</div>
